<mat-expansion-panel>
  <mat-expansion-panel-header class="wiring-header">
    <mat-panel-title class="wiring-header-title">
      <app-interface
        [interfaceConfiguration]="interfaceConfiguration"
      ></app-interface>
      <mat-chip-listbox>
        @for (device of devices; track device) {
        <mat-chip-option [disabled]="!hasWiring(device)">
          <mat-icon matChipAvatar>{{ deviceAvatar(device) }}</mat-icon>
          {{ device }}
        </mat-chip-option>
        }
      </mat-chip-listbox>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div
    class="d-flex flex-column"
    [ngClass]="{ disabled: !interfaceConfiguration.enabled }"
  >
    <div class="details mt-8 mb-16 d-flex flex-row">
      <div class="mr-32">
        <span class="text-medium-emphasis">Disabled Reason</span><br />
        <span>{{ interfaceConfiguration.disabledReason }}</span>
      </div>
      <div class="mr-32">
        <span class="text-medium-emphasis">Connector Name</span><br />
        <span>{{ connector?.name }}</span>
      </div>
      <div>
        <span class="text-medium-emphasis">Interface Activation</span>
        <div class="d-flex align-items-center">
          <span>{{ interfaceActivation }}</span>
          @if (hasComment) {
          <mat-icon
            class="comment-icon ml-8"
            matTooltip="Interface comment available"
            >comment
          </mat-icon>
          }
        </div>
      </div>
    </div>

    @for (wiring of wirings; track wiring; let last = $last) {
    <div class="mt-16">
      <app-wiring-diagram class="wiring" [wiring]="wiring">
      </app-wiring-diagram>
      <div class="wiring-comment mt-4" [ngClass]="{ 'mb-16': !last }">
        @if (hasWiringComment(wiring)) {
        <div class="d-flex align-items-center text-accent font-weight-bold">
          <mat-icon class="mr-8">info</mat-icon>
          <span>{{ wiring.comment }}</span>
        </div>
        }
      </div>
      @if (!last) {
      <mat-divider></mat-divider>
      }
    </div>
    }

    <mat-card appearance="outlined" [class.disabled]="!hasComment">
      <mat-card-title>
        Comments
        <mat-icon>comment</mat-icon>
      </mat-card-title>
      <mat-card-content>
        <span markdown>{{
          interfaceConfiguration.comment ? interfaceConfiguration.comment : "-"
        }}</span>
      </mat-card-content>
    </mat-card>

    @if (connector && connectorTerminals.length > 0) {
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>Connector</mat-expansion-panel-header>
      <div class="d-flex">
        <div class="mr-32">
          <span class="text-medium-emphasis">Connector Name</span><br />
          <span>{{ connector?.name }}</span>
        </div>

        @if (connectorTerminals.length > 0) {
        <div class="mr-32">
          <span class="text-medium-emphasis">Terminals</span><br />
          <table>
            @for (wire of connectorTerminals; track wire) {
            <tr>
              <td>{{ getConnectorPropertyLabel(wire.field) }}:</td>
              <td>{{ wire.value }}</td>
            </tr>
            }
          </table>
        </div>
        } @if (connectorProperties.length > 0) {
        <div class="mr-32">
          <span class="text-medium-emphasis">Properties</span><br />
          <table>
            @for (wire of connectorProperties; track wire) {
            <tr>
              <td>{{ getConnectorPropertyLabel(wire.field) }}:</td>
              <td>
                {{ formatConnectorPropertyValue(wire.field, wire.value) }}
              </td>
            </tr>
            }
          </table>
        </div>
        }
      </div>
    </mat-expansion-panel>
    }
  </div>
</mat-expansion-panel>
